import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { TiArrowSortedUp, TiArrowSortedDown } from "react-icons/ti";
import { FaRegEdit } from "react-icons/fa";
import { RiDeleteBin5Fill } from "react-icons/ri";
import { Table, Pagination } from "react-bootstrap";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import sort from "../../assets/sort.svg";
import filter from "../../assets/filter.svg";
import NewTransactions from "../../component/comman/NewTransactions";
import Popup from "reactjs-popup";
import { IoClose } from "react-icons/io5";
import OtpInput from "react-otp-input";
import { IoMdMore } from "react-icons/io";
import ToastMsg from "../../component/comman/ToastMsg";
import {
  dashboardList,
  deleteTransactions,
  updateTransactions,
  verifyPin,
} from "../../services/ApiServices";


function Journal() {
  const [otp, setOtp] = useState("");
  const [open, setOpen] = useState(false);
  const closeModal = () => {
    setOpen(false);
    setSelectedTransaction(null);
  };
  const [open2, setOpen2] = useState(false);
  const closeModal2 = () => setOpen2(false);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [customers, setCustomers] = useState([]);
  const [isNewTransactionPopupOpen, setIsNewTransactionPopupOpen] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [date, setDate] = useState("");
  const [actionType, setActionType] = useState("update");
  const [details, setDetails] = useState("");
  const [debitValue, setDebitValue] = useState("");
  const [creditValue, setCreditValue] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [pageInfo, setPageInfo] = useState({
    current_page: 1,
    total_pages: 1,
    has_next: false,
    has_previous: false,
  });
  useEffect(() => {
    if (selectedTransaction) {
      setDate(new Date().toISOString().split("T")[0]);
      setCustomerId(selectedTransaction.id || "");
      setDetails(selectedTransaction.details || "");
      setDebitValue(
        selectedTransaction.transaction_type === "debit"
          ? selectedTransaction.transaction_amount
          : ""
      );
      setCreditValue(
        selectedTransaction.transaction_type === "credit"
          ? selectedTransaction.transaction_amount
          : ""
      );
    }
  }, [selectedTransaction]);

  const handleAccounts = (sortOrder) => {
    const today = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format
    const startDate = today;  // Start date is today's date
    const endDate = today;
    getCustomersDetails({ start_date: startDate, end_date: endDate, all_transactions: true, page_type: "journal", transaction_type: sortOrder});

  };

  const handleUpdateTransaction = () => {
    const updatedData = {
      transaction_date: date,
      customer: customerId,
      transaction_type: debitValue ? "debit" : "credit",
      transaction_amount: debitValue || creditValue,
      details: details,
    };
    updateTransactions(updatedData)
      .then((res) => {
        if (res.status === 200) {
          ToastMsg("Transaction updated successfully", "success");
          closeModal2();
          getCustomersDetails();
        } else {
          ToastMsg("Failed to update transaction", "error");
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
        ToastMsg("Something went wrong", "error");
      });
  };

  const getCustomersDetails = useCallback(
    (params = {}) => {
      const today = new Date().toISOString().split('T')[0];    
      const queryParams = { ...params, start_date: today, end_date: today,  page_num: currentPage, per_page_data: itemsPerPage };
      dashboardList(queryParams)
        .then((res) => {
          console.log("API Response:", res.data.data);
          if (res.status === 200 && Array.isArray(res?.data?.data)) {
            setCustomers(res?.data?.data);
            setFilteredCustomers(res?.data?.data);
            setPageInfo(res?.data?.page_info);
            setTotalPages(res?.data?.page_info.total_pages);
          } else {
            setCustomers([]);
            setFilteredCustomers([]);
          }
        })
        .catch((err) => {
          console.error("API Error:", err);
          if (err.response?.status === 401) {
            navigate("/");
          }
          let error = err?.response?.data?.error || "something went wrong";
          ToastMsg(error, "error");
          setCustomers([]);
          setFilteredCustomers([]);
        });
    },
    [navigate, currentPage, itemsPerPage]
  );
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      getCustomersDetails();
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [getCustomersDetails]);

  useEffect(() => {
    setFilteredCustomers(customers);
    setTotalPages(Math.ceil(customers.length / itemsPerPage));
  }, [customers, itemsPerPage]);

  const handleSort = (sortOrder) => {
    const params = { order: sortOrder };
    getCustomersDetails(params);
  };

  useEffect(() => {
    getCustomersDetails();
  }, [getCustomersDetails,currentPage, itemsPerPage,]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const today = new Date();
  const formattedDate = `(${today
    .getDate()
    .toString()
    .padStart(2, "0")}/${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}/${today.getFullYear()})`;

  const openNewTransactionPopup = () => {
    setIsNewTransactionPopupOpen(true);
  };
  
  const closeNewTransactionPopup = () => {
    setIsNewTransactionPopupOpen(false);
  };

  const handleVerifyPin = (e) => {
    e.preventDefault();
    const data = {
        user_pin: otp,
    };
    verifyPin(data)
      .then((res) => {
        if (res.status === 200) {
          ToastMsg('Pin Verify successfully!', 'success');
          if (actionType === "update") {
            handleUpdateTransaction();
          } else if (actionType === "delete") {
            handleDeleteTransaction();
          }
          setOtp("")
          setOpen2(true)
          getCustomersDetails();
        } else {
          console.error('Failed to update details:', res?.data);
          ToastMsg('Pin Verify Failed', 'error');
        }
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          navigate('/');
        }
        let error = err?.response?.data?.error || 'something went wrong';
        ToastMsg(error, 'error');
      });
  };

  const handleDeleteTransaction = () => {
    const updatedData = {
      customer: customerId,
    };
    deleteTransactions(updatedData)
      .then((res) => {
        if (res.status === 200) {
          ToastMsg("Transaction Deleted successfully", "success");
          closeModal2();
          getCustomersDetails();
        } else {
          ToastMsg("Failed to update transaction", "error");
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
        ToastMsg("Something went wrong", "error");
      });
  };

  return (
    <>
      <div className="dasboard-content journal">
        <NewTransactions isOpenNow={isNewTransactionPopupOpen} onCloseNow={closeNewTransactionPopup} onTransactionSuccess={getCustomersDetails}/>
        <div className="card mb-4">
          <div className="card-body">
            <div className="card-header d-flex align-items-center justify-content-between">
              <h5>All Transactions <span>{formattedDate}</span></h5>
              <div className="filter d-flex align-items-center">
                <button
                  className="flex align-items-center add-btn"
                  style={{ marginRight: "15px" }}
                  onClick={openNewTransactionPopup}
                >
                  Add +
                </button>
                <div className="dropdown">
                  <button className="flex align-items-center">
                    <span>Sort</span>
                    <img src={sort} alt="icon" width={18} height={15} />
                  </button>
                  <div className="subMenu">
                    <ul>
                      <li onClick={() => handleSort("customer__name")}>Name <TiArrowSortedDown/></li>
                      <li onClick={() => handleSort("-customer__name")}>Name <TiArrowSortedUp/></li>
                      <li onClick={() => handleSort("transaction_date")}>Date <TiArrowSortedDown/></li>
                      <li onClick={() => handleSort("-transaction_date")}>Date <TiArrowSortedUp/></li>
                      <li onClick={() => handleSort("balance")}>Balance <TiArrowSortedDown/></li>
                      <li onClick={() => handleSort("-balance")}>Balance <TiArrowSortedUp/></li>
                    </ul>
                  </div>
                </div>
                <div className="dropdown" style={{marginLeft:"10px"}}>
                  <button className="flex align-items-center">
                    <span>Filter</span>
                    <img src={filter} alt="icon" width={18} height={15} />
                  </button>
                  <div className="subMenu">
                    <ul>
                      <li onClick={() => handleAccounts("")}>All</li>
                      <li onClick={() => handleAccounts("credit")}>Credit</li>
                      <li onClick={() => handleAccounts("debit")}>Debit</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="table-responsive journal">
              <Table className="table-centered table-striped table-hover mb-0">
                <thead className="table-light">
                  <tr>
                    <th style={{ cursor: "pointer" }}>Customer</th>
                    <th style={{ cursor: "pointer" }}>Details</th>
                    <th style={{ cursor: "pointer" }}>Debit & Credit</th>
                    <th style={{ cursor: "pointer" }}>Balance</th>
                    <th style={{ cursor: "pointer" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCustomers.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center">
                        No Data Found
                      </td>
                    </tr>
                  ) : (
                    filteredCustomers.map((user, index) => (
                      <tr key={index}>
                        <td>{user.customer__name}</td>
                        <td className="detail-td">{user.details}</td>
                        <td
                          className={
                            user.transaction_type === "debit" ? "green" : "red"
                          }
                        >
                          €{" "}
                          {user.transaction_amount}
                          {user.transaction_type === "debit" ? (
                            <TiArrowSortedDown />
                          ) : (
                            <TiArrowSortedUp />
                          )}
                        </td>
                        <td>€{" "}{user.balance || "00.00"}</td>
                        <td>
                          <div className="dropdown">
                            <IoMdMore/>
                            <div className="subMenu">
                              <ul>
                                <li onClick={() => {setSelectedTransaction(user); setOpen(true);}}>Edit</li>
                                <li onClick={() => {setSelectedTransaction(user); setActionType("delete"); setOpen2((open2) => !open2)}}>Delete</li>
                              </ul>
                            </div>
                          </div>
                          <FaRegEdit onClick={() => {
                            setSelectedTransaction(user);
                            setOpen(true);
                          }} />
                          <RiDeleteBin5Fill 
                            onClick={() => {
                              setSelectedTransaction(user);
                              setActionType("delete"); 
                              setOpen2((open2) => !open2)
                            }}
                          />
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
              <div className="d-flex justify-content-between align-items-center border-top pagination-wrapper">
                <div className="text-muted small">
                  {(currentPage - 1) * itemsPerPage + 1}-
                  {10*(currentPage - 1) + filteredCustomers.length}
                  {" "}of {pageInfo.total_data || "0"}
                </div>
                <div className="d-flex align-items-center">
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="itemsPerPage">Rows per page:</label>
                    <select
                      id="itemsPerPage"
                      className="form-control"
                      value={itemsPerPage} 
                      onChange={(e) => setItemsPerPage(Number(e.target.value))}
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                    </select>
                    <MdOutlineKeyboardArrowDown />
                  </div>
                  <Pagination size="sm" className="pagination-rounded mb-0">
                    <Pagination.Prev
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    />
                    <p>
                      <span>{currentPage}</span>/{pageInfo.total_pages}
                    </p>
                    <Pagination.Next
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === pageInfo.total_pages}
                    />
                  </Pagination>
                </div>
              </div>
          </div>
        </div>
      </div>
      <Popup
        open={open}
        closeOnDocumentClick={false}
        onClose={() => {
          setOpen(false);
          setSelectedTransaction(null);
        }}
        className="new-user journal-pop"
      >
        <div className="card">
          <div className="card-body">
            <div className="flex align-items-center justify-content-between">
              <h5>Update Transaction</h5>
              <IoClose onClick={() => {
                setOpen(false);
                setSelectedTransaction(null);
              }} />
            </div>
            <form className="row">
              <div className="form-group col-6">
                <label htmlFor="date">Date</label>
                <input
                  type="date"
                  id="date"
                  className="form-control"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  max={new Date().toISOString().split("T")[0]}
                />
              </div>
              <div className="form-group col-6">
                <label htmlFor="debit">Select Account</label>
                <input
                  type="text"
                  id="customerName"
                  className="form-control"
                  value={selectedTransaction?.customer__name}
                  disabled
                />
              </div>
              <div className="form-group col-6">
                <label htmlFor="debit">Debit</label>
                <input
                  type="number"
                  id="debit"
                  className="form-control"
                  value={debitValue}
                  onChange={(e) => setDebitValue(e.target.value)}
                  disabled={!!creditValue}
                />
              </div>
              <div className="form-group col-6">
                <label htmlFor="Credit">Credit</label>
                <input
                  type="number"
                  id="Credit"
                  className="form-control"
                  value={creditValue}
                  onChange={(e) => setCreditValue(e.target.value )}
                  disabled={!!debitValue}
                />
              </div>
              <div className="form-group">
                <label htmlFor="details">Details</label>
                <textarea
                  className="form-control"
                  id="details"
                  rows="3"
                  value={details}
                  onChange={(e) => setDetails(e.target.value)}
                ></textarea>
              </div>
            </form>
            <div className="button-wrapper text-right">
              <button
                className="btn"
                onClick={() => {
                  setOpen(false); 
                  setSelectedTransaction(null); 
                }}
              >
                Cancel
              </button>
              <button
                className="btn"
                onClick={() => setOpen2((open2) => !open2)}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </Popup>
      <Popup
        open={open2}
        closeOnDocumentClick={false}
        onClose={closeModal}
        className="new-user journal-pop"
      >
        <div className="card">
          <div className="card-body">
            <div className="flex align-items-center justify-content-between">
              <h5 className="pb-4">Enter Pin</h5>
            </div>
            <div className="otp-wrapper">
              <OtpInput
                value={otp}
                onChange={setOtp}
                numInputs={6}
                renderSeparator={" "}
                inputType="password"
                renderInput={(props) => <input {...props} />}
              />
            </div>
            <div className="button-wrapper text-right">
              <button className="btn" onClick={closeModal2}>
                Cancel
              </button>
              <button className="btn" onClick={handleVerifyPin}>Update</button>
            </div>
          </div>
        </div>
      </Popup>
    </>
  );
}

export default Journal;
